<template>
  <form novalidate @submit.prevent="loginUser">
    <b-form-group label="Username" label-for="inputTextEmail">
      <b-form-input
        id="inputTextEmail"
        v-model="form.email"
        type="text"
        autocomplete="username"
        placeholder="Enter username/email"
        :class="errors.email || $v.form.email.$error ? 'is-invalid' : ''"
      ></b-form-input>
      <b-form-invalid-feedback v-if="errors.email">
        {{ errors.email }}
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.form.email.required">
        Can not be empty
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Password" label-for="inputTextPassword">
      <div class="field-with-toggle">
        <b-form-input
          id="inputTextPassword"
          v-model="form.password"
          :type="passwordVisible ? 'text' : 'password'"
          autocomplete="current-password"
          placeholder="Enter password"
          :class="errors.password || $v.form.password.$error ? 'is-invalid' : ''"
        ></b-form-input>
        <button
          type="button"
          class="field-toggle"
          :aria-pressed="passwordVisible ? 'true' : 'false'"
          @click="passwordVisible = !passwordVisible"
        >{{ passwordVisible ? 'Hide' : 'Show' }}</button>
        <b-form-invalid-feedback v-if="errors.password">
          {{ errors.password }}
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.form.password.required">
          Can not be empty
        </b-form-invalid-feedback>
      </div>
    </b-form-group>

    <b-form-checkbox
      id="remember_email"
      v-model="remember_email"
      name="remember_email"
      :value="true"
      :unchecked-value="false"
    >
      Remember my email
    </b-form-checkbox>

    <button class="submit-btn" type="submit" :disabled="isSubmit">
      {{ isSubmit ? 'Signing in…' : 'Sign in' }}
    </button>

    <p v-if="formError" class="form-status" data-tone="error" role="status" aria-live="polite">
      {{ formError }}
    </p>

    <p class="card-links">
      <router-link class="card-link" :to="{ name: 'ForgotPassword' }">Forgot password</router-link>
    </p>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import axiosInstance, { setAuthTokens } from '@/services/_AxiosInstance';

export default {
  name: 'LoginForm',
  mixins: [validationMixin],
  data() {
    return {
      errors: {},
      formError: '',
      form: {
        email: undefined,
        password: undefined,
      },
      isSubmit: false,
      passwordVisible: false,
      remember_email: true,
    };
  },
  validations: {
    form: {
      email: {
        required,
      },
      password: {
        required,
      },
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.email': function () {
      this.$v.form.email.$touch();
    },
    // eslint-disable-next-line func-names
    'form.password': function () {
      this.$v.form.password.$touch();
    },
  },
  mounted() {
    const lastEmail = localStorage.getItem('mantraz_login_email');
    if (lastEmail) {
      this.form.email = lastEmail;
    }
  },
  methods: {
    async loginUser() {
      this.resetError();
      this.isSubmit = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.isSubmit = false;
        return;
      }

      const formData = new FormData();
      formData.append('username', this.form.email);
      formData.append('password', this.form.password);

      try {
        const res = await axiosInstance.post('/security/authentication/login', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const token = res.data.token;
        if (!token) {
          throw new Error('Invalid Username or Password');
        }

        setAuthTokens(token, res.data.refreshToken);
        if (this.remember_email) {
          localStorage.setItem('mantraz_login_email', this.form.email);
        } else {
          localStorage.removeItem('mantraz_login_email');
        }
        this.$emit('onSuccess');
      } catch (err) {
        this.isSubmit = false;
        // backend gak nyebut field mana yang salah, jadi pesannya satu buat seluruh form
        this.formError = err.response?.data?.status?.message || 'Invalid Username or Password';
        this.$emit('onFailure', this.formError);
      }
    },
    resetError() {
      this.errors = {};
      this.formError = '';
    },
  },
};
</script>
